/*
 *  Copyright (c) Qwoach LLC 2023. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 4/12/2023
 */

export const ProfileTypeEnum = Object.freeze({
	USER: 'user', //auth user
	COACH: 'coach', //auth user
	CLIENT: 'client',
	PROSPECT: 'prospect',
	TEAM_MEMBER: 'team_member',
	QWOACH_PLATFORM: 'qwoach_platform',
})


export const ProfileTypeClientObj = Object.freeze({label: 'Client', labelShort: 'Client', value: ProfileTypeEnum.CLIENT,})
export const ProfileTypeMemberObj = Object.freeze({label: 'Team Member', labelShort: 'Member', value: ProfileTypeEnum.TEAM_MEMBER,})

export const ProfileTypeOptions = [
    ProfileTypeClientObj,
    ProfileTypeMemberObj,
]

export const findProfileTypeLabelByValue = (value) => {
    const option = ProfileTypeOptions.find(option => option.value === value)
    return option ? option.labelShort : ''
}
